require("core-js/modules/es.promise.finally.js");
/*! For license information please see contentstack.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Contentstack = t() : e.Contentstack = t();
}(self, () => (() => {
  "use strict";

  var e = {
      971: (e, t) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = {
          protocol: "https",
          host: "cdn.contentstack.io",
          port: 443,
          version: "v3",
          urls: {
            sync: "/stacks/sync",
            content_types: "/content_types/",
            entries: "/entries/",
            assets: "/assets/",
            environments: "/environments/"
          },
          live_preview: {
            enable: !1,
            host: "api.contentstack.io"
          }
        };
      },
      472: () => {},
      776: (e, t) => {
        var r,
          n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          };
        function i(e) {
          return {
            text: e["#text"],
            itemUid: e["data-sys-entry-uid"] || e["data-sys-asset-uid"],
            itemType: e.type,
            styleType: e["sys-style-type"],
            attributes: e,
            contentTypeUid: e["data-sys-content-type-uid"]
          };
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), function (e) {
          e.BLOCK = "block", e.INLINE = "inline", e.LINK = "link", e.DISPLAY = "display", e.DOWNLOAD = "download";
        }(r || (r = {}));
        var o = r,
          s = function (e, t) {
            return s = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }, s(e, t);
          };
        function u(e, t) {
          function r() {
            this.constructor = e;
          }
          s(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
        }
        var a = function () {
          return a = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
          }, a.apply(this, arguments);
        };
        function c(e) {
          for (var t = {}, r = 0; r < e.attributes.length; r++) t[e.attributes.item(r).name] = e.attributes.item(r).value;
          return e.childNodes.forEach(function (e) {
            var r = e;
            t = a(a({}, t), function (e) {
              var t = {};
              return 3 === e.nodeType ? t["#text"] = e.textContent : 1 === e.nodeType && (t[e.nodeName.toLowerCase()] = c(e)), t;
            }(r));
          }), t;
        }
        var f,
          l = "documentfragmentcontainer";
        String.prototype.forEachEmbeddedItem = function (e) {
          var t = "<".concat(l, ">").concat(this.toString(), "</").concat(l, ">"),
            r = new DOMParser().parseFromString(t, "text/html");
          r.querySelectorAll(".embedded-entry").forEach(function (t) {
            e(t.outerHTML, i(c(t)));
          }), r.querySelectorAll(".embedded-asset").forEach(function (t) {
            e(t.outerHTML, i(c(t)));
          });
        };
        var h,
          y = ((f = {})[o.BLOCK] = function (e) {
            return "<div><p>".concat(e.title || e.uid, "</p><p>Content type: <span>").concat(e._content_type_uid || (e.system ? e.system.content_type_uid : ""), "</span></p></div>");
          }, f[o.INLINE] = function (e) {
            return "<span>".concat(e.title || e.uid, "</span>");
          }, f[o.LINK] = function (e, t) {
            return '<a href="'.concat(e.url, '">').concat(t.text || e.title || e.uid || (e.system ? e.system.uid : ""), "</a>");
          }, f[o.DISPLAY] = function (e, t) {
            return '<img src="'.concat(e.url, '" alt="').concat(t.attributes.alt || e.title || e.filename || e.uid || (e.system ? e.system.uid : ""), '" />');
          }, f[o.DOWNLOAD] = function (e, t) {
            return '<a href="'.concat(e.url, '">').concat(t.text || e.title || e.uid || (e.system ? e.system.content_type_uid : ""), "</a>");
          }, f);
        function d(e, t) {
          return "entry" === e.itemType ? (r = e.itemUid, n = e.contentTypeUid, void 0 === (i = t) && (i = []), i.filter(function (e) {
            if (e.uid && e.uid === r && e._content_type_uid === n || e.system && e.system.uid === r && e.system.content_type_uid === n) return e;
          })) : function (e, t) {
            return void 0 === t && (t = []), t.filter(function (t) {
              if (t.uid && t.uid === e || t.system && t.system.uid === e) return t;
            });
          }(e.itemUid, t);
          var r, n, i;
        }
        function p(e, t) {
          if (e && void 0 !== e && t && void 0 !== t && void 0 !== t._embedded_items) {
            var r = t;
            return d(e, Object.values(r._embedded_items || []).reduce(function (e, t) {
              return e.concat(t);
            }, []));
          }
          return [];
        }
        function v(e, t, r) {
          if (!e && void 0 === e || !t && void 0 === t) return "";
          if (r && void 0 !== r[t.styleType]) {
            var n = r[t.styleType];
            if (void 0 !== t.attributes["data-sys-content-type-uid"] && "function" != typeof n && void 0 !== n[t.attributes["data-sys-content-type-uid"]]) return n[t.attributes["data-sys-content-type-uid"]](e, t);
            if (void 0 !== t.attributes["data-sys-content-type-uid"] && "function" != typeof n && void 0 !== n.$default) return n.$default(e, t);
            if (void 0 !== t.contentTypeUid && "function" != typeof n && void 0 !== n[t.contentTypeUid]) return n[t.contentTypeUid](e, t);
            if (void 0 !== t.contentTypeUid && "function" != typeof n && void 0 !== n.$default) return n.$default(e, t);
            if ("function" == typeof n) return n(e, t);
          }
          return (0, y[t.styleType])(e, t);
        }
        function _(e, t, r) {
          b(e.split("."), t, r);
        }
        function b(e, t, r) {
          if (e) {
            var i = e[0];
            if (1 === e.length && t[i]) t[i] = r(t[i]);else if (e.length > 0 && t[i]) {
              var o = e.slice(1);
              if (Array.isArray(t[i])) for (var s = 0, u = t[i]; s < u.length; s++) b(o, u[s], r);else "object" === n(t[i]) && b(o, t[i], r);
            }
          }
        }
        function m(e, t) {
          if (!e || void 0 === e) return "";
          if ("string" == typeof e) {
            var r = e;
            return e.forEachEmbeddedItem(function (e, n) {
              r = function (e, t, r, n) {
                var i = v(p(r, n.entry)[0], r, n.renderOption);
                return e.replace(t, i);
              }(r, e, n, t);
            }), r;
          }
          var n = [];
          return e.forEach(function (e) {
            n.push(m(e, t));
          }), n;
        }
        !function (e) {
          e.DOCUMENT = "doc", e.PARAGRAPH = "p", e.LINK = "a", e.IMAGE = "img", e.EMBED = "embed", e.HEADING_1 = "h1", e.HEADING_2 = "h2", e.HEADING_3 = "h3", e.HEADING_4 = "h4", e.HEADING_5 = "h5", e.HEADING_6 = "h6", e.ORDER_LIST = "ol", e.UNORDER_LIST = "ul", e.LIST_ITEM = "li", e.HR = "hr", e.TABLE = "table", e.TABLE_HEADER = "thead", e.TABLE_BODY = "tbody", e.TABLE_FOOTER = "tfoot", e.TABLE_ROW = "tr", e.TABLE_HEAD = "th", e.TABLE_DATA = "td", e.BLOCK_QUOTE = "blockquote", e.CODE = "code", e.TEXT = "text", e.REFERENCE = "reference";
        }(h || (h = {}));
        var g,
          O = h;
        !function (e) {
          e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.STRIKE_THROUGH = "strikethrough", e.INLINE_CODE = "inlineCode", e.SUBSCRIPT = "subscript", e.SUPERSCRIPT = "superscript";
        }(g || (g = {}));
        var q,
          w = g,
          E = function () {},
          T = function (e) {
            function t() {
              var t = e.call(this) || this;
              return t.type = O.DOCUMENT, t;
            }
            return u(t, e), t;
          }(E),
          A = function (e) {
            function t(t) {
              var r = e.call(this) || this;
              return r.text = t, r;
            }
            return u(t, e), t;
          }(E),
          P = ((q = {})[O.DOCUMENT] = function (e) {
            return "";
          }, q[O.PARAGRAPH] = function (e, t) {
            return "<p>".concat(t(e.children), "</p>");
          }, q[O.LINK] = function (e, t) {
            return '<a href="'.concat(e.attrs.href || e.attrs.url, '">').concat(t(e.children), "</a>");
          }, q[O.IMAGE] = function (e, t) {
            return '<img src="'.concat(e.attrs.src || e.attrs.url, '" />').concat(t(e.children));
          }, q[O.EMBED] = function (e, t) {
            return '<iframe src="'.concat(e.attrs.src || e.attrs.url, '">').concat(t(e.children), "</iframe>");
          }, q[O.HEADING_1] = function (e, t) {
            return "<h1>".concat(t(e.children), "</h1>");
          }, q[O.HEADING_2] = function (e, t) {
            return "<h2>".concat(t(e.children), "</h2>");
          }, q[O.HEADING_3] = function (e, t) {
            return "<h3>".concat(t(e.children), "</h3>");
          }, q[O.HEADING_4] = function (e, t) {
            return "<h4>".concat(t(e.children), "</h4>");
          }, q[O.HEADING_5] = function (e, t) {
            return "<h5>".concat(t(e.children), "</h5>");
          }, q[O.HEADING_6] = function (e, t) {
            return "<h6>".concat(t(e.children), "</h6>");
          }, q[O.ORDER_LIST] = function (e, t) {
            return "<ol>".concat(t(e.children), "</ol>");
          }, q[O.UNORDER_LIST] = function (e, t) {
            return "<ul>".concat(t(e.children), "</ul>");
          }, q[O.LIST_ITEM] = function (e, t) {
            return "<li>".concat(t(e.children), "</li>");
          }, q[O.HR] = function (e, t) {
            return "<hr>";
          }, q[O.TABLE] = function (e, t) {
            return "<table>".concat(t(e.children), "</table>");
          }, q[O.TABLE_HEADER] = function (e, t) {
            return "<thead>".concat(t(e.children), "</thead>");
          }, q[O.TABLE_BODY] = function (e, t) {
            return "<tbody>".concat(t(e.children), "</tbody>");
          }, q[O.TABLE_FOOTER] = function (e, t) {
            return "<tfoot>".concat(t(e.children), "</tfoot>");
          }, q[O.TABLE_ROW] = function (e, t) {
            return "<tr>".concat(t(e.children), "</tr>");
          }, q[O.TABLE_HEAD] = function (e, t) {
            return "<th>".concat(t(e.children), "</th>");
          }, q[O.TABLE_DATA] = function (e, t) {
            return "<td>".concat(t(e.children), "</td>");
          }, q[O.BLOCK_QUOTE] = function (e, t) {
            return "<blockquote>".concat(t(e.children), "</blockquote>");
          }, q[O.CODE] = function (e, t) {
            return "<code>".concat(t(e.children), "</code>");
          }, q.reference = function (e, t) {
            return "";
          }, q.default = function (e, t) {
            return t(e.children);
          }, q[w.BOLD] = function (e) {
            return "<strong>".concat(e, "</strong>");
          }, q[w.ITALIC] = function (e) {
            return "<em>".concat(e, "</em>");
          }, q[w.UNDERLINE] = function (e) {
            return "<u>".concat(e, "</u>");
          }, q[w.STRIKE_THROUGH] = function (e) {
            return "<strike>".concat(e, "</strike>");
          }, q[w.INLINE_CODE] = function (e) {
            return "<span>".concat(e, "</span>");
          }, q[w.SUBSCRIPT] = function (e) {
            return "<sub>".concat(e, "</sub>");
          }, q[w.SUPERSCRIPT] = function (e) {
            return "<sup>".concat(e, "</sup>");
          }, q);
        function k(e, t) {
          for (var r = 0, n = e; r < n.length; r++) t(n[r]);
        }
        function S(e, t, r) {
          if (!(e instanceof Array) && "doc" !== e.type) return e;
          if (e instanceof Array) {
            var n = [];
            return e.forEach(function (e) {
              n.push(S(e, t, r));
            }), n;
          }
          var i = a(a({}, P), t);
          return j(e.children, i, r);
        }
        function j(e, t, r) {
          return e.map(function (e) {
            return function (e, t, r) {
              if (e.type) {
                if ("reference" === e.type) return function (e, t, r) {
                  function n(e) {
                    return t[e.type](e, void 0);
                  }
                  if (!r && void 0 !== t[e.type]) return n(e);
                  if (!r) return "";
                  var i,
                    o = (i = e.attrs, {
                      text: (e.children && e.children.length > 0 ? e.children[0] : {}).text,
                      itemUid: i["entry-uid"] || i["asset-uid"],
                      itemType: i.type,
                      styleType: i["display-type"],
                      attributes: i,
                      contentTypeUid: i["content-type-uid"]
                    }),
                    s = r(o);
                  return s || void 0 === t[e.type] ? v(s, o, t) : n(e);
                }(e, t, r);
                var n = function (e) {
                  return j(e, t, r);
                };
                return void 0 !== t[e.type] ? t[e.type](e, n) : t.default(e, n);
              }
              return function (e, t) {
                var r = e.text;
                return e.superscript && (r = t[w.SUPERSCRIPT](r)), e.subscript && (r = t[w.SUBSCRIPT](r)), e.inlineCode && (r = t[w.INLINE_CODE](r)), e.strikethrough && (r = t[w.STRIKE_THROUGH](r)), e.underline && (r = t[w.UNDERLINE](r)), e.italic && (r = t[w.ITALIC](r)), e.bold && (r = t[w.BOLD](r)), r;
              }(e, t);
            }(e, t, r);
          }).join("");
        }
        var D = {
          jsonToHTML: function e(t) {
            t.entry instanceof Array ? k(t.entry, function (r) {
              e({
                entry: r,
                paths: t.paths,
                renderOption: t.renderOption
              });
            }) : function (e) {
              for (var t = 0, r = e.paths; t < r.length; t++) _(r[t], e.entry, function (t) {
                if (t && t.json) {
                  var r = t.embedded_itemsConnection ? t.embedded_itemsConnection.edges : [],
                    n = Object.values(r || []).reduce(function (e, t) {
                      return e.concat(t.node);
                    }, []);
                  return S(t.json, e.renderOption, function (e) {
                    return d(e, n)[0];
                  });
                }
                return t;
              });
            }({
              entry: t.entry,
              paths: t.paths,
              renderOption: t.renderOption
            });
          }
        };
        function C(e, t, r, i) {
          var o = {};
          return Object.entries(e).forEach(function (e) {
            var s = e[0],
              u = e[1];
            "object" === (void 0 === u ? "undefined" : n(u)) ? Array.isArray(u) ? u.forEach(function (e, a) {
              null != e && void 0 !== e._content_type_uid && void 0 !== e.uid ? u[a].$ = C(e, "".concat(e._content_type_uid, ".").concat(e.uid, ".").concat(e.locale || i), r, i) : "object" === (void 0 === e ? "undefined" : n(e)) ? e.$ = C(e, "".concat(t, ".").concat(s, ".").concat(a), r, i) : o[s] = I("".concat(t, ".").concat(s), r);
            }) : u && (u.$ = C(u, "".concat(t, ".").concat(s), r, i)) : o[s] = I("".concat(t, ".").concat(s), r);
          }), o;
        }
        function I(e, t) {
          return t ? {
            "data-cslp": e
          } : "data-cslp=".concat(e);
        }
        t.Document = T, t.GQL = D, t.MarkType = w, t.Node = E, t.NodeType = O, t.StyleType = o, t.TextNode = A, t.addEditableTags = function (e, t, r, n) {
          void 0 === n && (n = "en-us"), e && (e.$ = C(e, "".concat(t, ".").concat(e.uid, ".").concat(n), r, n));
        }, t.attributeToString = function (e) {
          var t = "",
            r = function (r) {
              if (Object.prototype.hasOwnProperty.call(e, r)) {
                var i = e[r];
                if (i instanceof Array) {
                  var o = "",
                    s = !0;
                  i.forEach(function (e) {
                    s ? (o += "".concat(e), s = !1) : o += ", ".concat(e);
                  }), i = o;
                } else if ("object" === (void 0 === i ? "undefined" : n(i))) {
                  var u = "";
                  for (var a in i) if (Object.prototype.hasOwnProperty.call(i, a)) {
                    var c = i[a];
                    u += "".concat(a, ":").concat(c, "; ");
                  }
                  i = u;
                }
                t += " ".concat(r, '="').concat(i, '"');
              }
            };
          for (var i in e) r(i);
          return t;
        }, t.jsonToHTML = function e(t) {
          t.entry instanceof Array ? k(t.entry, function (r) {
            e({
              entry: r,
              paths: t.paths,
              renderOption: t.renderOption
            });
          }) : function (e) {
            for (var t = 0, r = e.paths; t < r.length; t++) _(r[t], e.entry, function (t) {
              return S(t, e.renderOption, function (t) {
                return p(t, e.entry)[0];
              });
            });
          }({
            entry: t.entry,
            paths: t.paths,
            renderOption: t.renderOption
          });
        }, t.render = function (e) {
          function t(t, r) {
            _(t, r, function (t) {
              return m(t, {
                entry: r,
                renderOption: e.renderOption
              });
            });
          }
          function r(r) {
            e.paths && 0 !== e.paths.length ? e.paths.forEach(function (e) {
              t(e, r);
            }) : Object.keys(a({}, r._embedded_items)).forEach(function (e) {
              t(e, r);
            });
          }
          e.entry instanceof Array ? e.entry.forEach(function (e) {
            r(e);
          }) : r(e.entry);
        }, t.renderContent = m;
      },
      483: (e, t, r) => {
        var n,
          i,
          o,
          s = r(472),
          u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          };
        o = function () {
          function e(e) {
            return "function" == typeof e;
          }
          var t = Array.isArray ? Array.isArray : function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            },
            r = 0,
            n = void 0,
            i = void 0,
            o = function (e, t) {
              d[r] = e, d[r + 1] = t, 2 === (r += 2) && (i ? i(p) : g());
            },
            a = "undefined" != typeof window ? window : void 0,
            c = a || {},
            f = c.MutationObserver || c.WebKitMutationObserver,
            l = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
            h = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
          function y() {
            var e = setTimeout;
            return function () {
              return e(p, 1);
            };
          }
          var d = new Array(1e3);
          function p() {
            for (var e = 0; e < r; e += 2) (0, d[e])(d[e + 1]), d[e] = void 0, d[e + 1] = void 0;
            r = 0;
          }
          var v,
            _,
            b,
            m,
            g = void 0;
          function O(e, t) {
            var r = this,
              n = new this.constructor(E);
            void 0 === n[w] && N(n);
            var i = r._state;
            if (i) {
              var s = arguments[i - 1];
              o(function () {
                return B(i, n, s, r._result);
              });
            } else I(r, n, e, t);
            return n;
          }
          function q(e) {
            if (e && "object" === (void 0 === e ? "undefined" : u(e)) && e.constructor === this) return e;
            var t = new this(E);
            return S(t, e), t;
          }
          l ? g = function () {
            return process.nextTick(p);
          } : f ? (_ = 0, b = new f(p), m = document.createTextNode(""), b.observe(m, {
            characterData: !0
          }), g = function () {
            m.data = _ = ++_ % 2;
          }) : h ? ((v = new MessageChannel()).port1.onmessage = p, g = function () {
            return v.port2.postMessage(0);
          }) : g = void 0 === a ? function () {
            try {
              var e = Function("return this")().require("vertx");
              return void 0 !== (n = e.runOnLoop || e.runOnContext) ? function () {
                n(p);
              } : y();
            } catch (e) {
              return y();
            }
          }() : y();
          var w = Math.random().toString(36).substring(2);
          function E() {}
          var T = void 0,
            A = 1,
            P = 2;
          function k(t, r, n) {
            r.constructor === t.constructor && n === O && r.constructor.resolve === q ? function (e, t) {
              t._state === A ? D(e, t._result) : t._state === P ? C(e, t._result) : I(t, void 0, function (t) {
                return S(e, t);
              }, function (t) {
                return C(e, t);
              });
            }(t, r) : void 0 === n ? D(t, r) : e(n) ? function (e, t, r) {
              o(function (e) {
                var n = !1,
                  i = function (r, i, o, s) {
                    try {
                      r.call(i, function (r) {
                        n || (n = !0, t !== r ? S(e, r) : D(e, r));
                      }, function (t) {
                        n || (n = !0, C(e, t));
                      });
                    } catch (e) {
                      return e;
                    }
                  }(r, t, 0, 0, e._label);
                !n && i && (n = !0, C(e, i));
              }, e);
            }(t, r, n) : D(t, r);
          }
          function S(e, t) {
            if (e === t) C(e, new TypeError("You cannot resolve a promise with itself"));else if (i = void 0 === (n = t) ? "undefined" : u(n), null === n || "object" !== i && "function" !== i) D(e, t);else {
              var r = void 0;
              try {
                r = t.then;
              } catch (t) {
                return void C(e, t);
              }
              k(e, t, r);
            }
            var n, i;
          }
          function j(e) {
            e._onerror && e._onerror(e._result), R(e);
          }
          function D(e, t) {
            e._state === T && (e._result = t, e._state = A, 0 !== e._subscribers.length && o(R, e));
          }
          function C(e, t) {
            e._state === T && (e._state = P, e._result = t, o(j, e));
          }
          function I(e, t, r, n) {
            var i = e._subscribers,
              s = i.length;
            e._onerror = null, i[s] = t, i[s + A] = r, i[s + P] = n, 0 === s && e._state && o(R, e);
          }
          function R(e) {
            var t = e._subscribers,
              r = e._state;
            if (0 !== t.length) {
              for (var n = void 0, i = void 0, o = e._result, s = 0; s < t.length; s += 3) n = t[s], i = t[s + r], n ? B(r, n, i, o) : i(o);
              e._subscribers.length = 0;
            }
          }
          function B(t, r, n, i) {
            var o = e(n),
              s = void 0,
              u = void 0,
              a = !0;
            if (o) {
              try {
                s = n(i);
              } catch (e) {
                a = !1, u = e;
              }
              if (r === s) return void C(r, new TypeError("A promises callback cannot return that same promise."));
            } else s = i;
            r._state !== T || (o && a ? S(r, s) : !1 === a ? C(r, u) : t === A ? D(r, s) : t === P && C(r, s));
          }
          var H = 0;
          function N(e) {
            e[w] = H++, e._state = void 0, e._result = void 0, e._subscribers = [];
          }
          var x = function () {
              function e(e, r) {
                this._instanceConstructor = e, this.promise = new e(E), this.promise[w] || N(this.promise), t(r) ? (this.length = r.length, this._remaining = r.length, this._result = new Array(this.length), 0 === this.length ? D(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(r), 0 === this._remaining && D(this.promise, this._result))) : C(this.promise, new Error("Array Methods must be provided an Array"));
              }
              return e.prototype._enumerate = function (e) {
                for (var t = 0; this._state === T && t < e.length; t++) this._eachEntry(e[t], t);
              }, e.prototype._eachEntry = function (e, t) {
                var r = this._instanceConstructor,
                  n = r.resolve;
                if (n === q) {
                  var i = void 0,
                    o = void 0,
                    s = !1;
                  try {
                    i = e.then;
                  } catch (e) {
                    s = !0, o = e;
                  }
                  if (i === O && e._state !== T) this._settledAt(e._state, t, e._result);else if ("function" != typeof i) this._remaining--, this._result[t] = e;else if (r === L) {
                    var u = new r(E);
                    s ? C(u, o) : k(u, e, i), this._willSettleAt(u, t);
                  } else this._willSettleAt(new r(function (t) {
                    return t(e);
                  }), t);
                } else this._willSettleAt(n(e), t);
              }, e.prototype._settledAt = function (e, t, r) {
                var n = this.promise;
                n._state === T && (this._remaining--, e === P ? C(n, r) : this._result[t] = r), 0 === this._remaining && D(n, this._result);
              }, e.prototype._willSettleAt = function (e, t) {
                var r = this;
                I(e, void 0, function (e) {
                  return r._settledAt(A, t, e);
                }, function (e) {
                  return r._settledAt(P, t, e);
                });
              }, e;
            }(),
            L = function () {
              function t(e) {
                this[w] = H++, this._result = this._state = void 0, this._subscribers = [], E !== e && ("function" != typeof e && function () {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof t ? function (e, t) {
                  try {
                    t(function (t) {
                      S(e, t);
                    }, function (t) {
                      C(e, t);
                    });
                  } catch (t) {
                    C(e, t);
                  }
                }(this, e) : function () {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
              }
              return t.prototype.catch = function (e) {
                return this.then(null, e);
              }, t.prototype.finally = function (t) {
                var r = this,
                  n = r.constructor;
                return e(t) ? r.then(function (e) {
                  return n.resolve(t()).then(function () {
                    return e;
                  });
                }, function (e) {
                  return n.resolve(t()).then(function () {
                    throw e;
                  });
                }) : r.then(t, t);
              }, t;
            }();
          return L.prototype.then = O, L.all = function (e) {
            return new x(this, e).promise;
          }, L.race = function (e) {
            var r = this;
            return t(e) ? new r(function (t, n) {
              for (var i = e.length, o = 0; o < i; o++) r.resolve(e[o]).then(t, n);
            }) : new r(function (e, t) {
              return t(new TypeError("You must pass an array to race."));
            });
          }, L.resolve = q, L.reject = function (e) {
            var t = new this(E);
            return C(t, e), t;
          }, L._setScheduler = function (e) {
            i = e;
          }, L._setAsap = function (e) {
            o = e;
          }, L._asap = o, L.polyfill = function () {
            var e = void 0;
            if (void 0 !== s) e = s;else if ("undefined" != typeof self) e = self;else try {
              e = Function("return this")();
            } catch (e) {
              throw new Error("polyfill failed because global object is unavailable in this environment");
            }
            var t = e.Promise;
            if (t) {
              var r = null;
              try {
                r = Object.prototype.toString.call(t.resolve());
              } catch (e) {}
              if ("[object Promise]" === r && !t.cast) return;
            }
            e.Promise = L;
          }, L.Promise = L, L;
        }, "object" === u(t) ? e.exports = o() : void 0 === (i = "function" == typeof (n = o) ? n.call(t, r, t, e) : n) || (e.exports = i);
      },
      51: (e, t, r) => {
        r(395), e.exports = self.fetch.bind(self);
      },
      395: (e, t) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        };
        t.Headers = f, t.Request = _, t.Response = m, t.fetch = q;
        var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== n && n,
          i = {
            searchParams: "URLSearchParams" in n,
            iterable: "Symbol" in n && "iterator" in Symbol,
            blob: "FileReader" in n && "Blob" in n && function () {
              try {
                return new Blob(), !0;
              } catch (e) {
                return !1;
              }
            }(),
            formData: "FormData" in n,
            arrayBuffer: "ArrayBuffer" in n
          };
        if (i.arrayBuffer) var o = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          s = ArrayBuffer.isView || function (e) {
            return e && o.indexOf(Object.prototype.toString.call(e)) > -1;
          };
        function u(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
          return e.toLowerCase();
        }
        function a(e) {
          return "string" != typeof e && (e = String(e)), e;
        }
        function c(e) {
          var t = {
            next: function () {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return i.iterable && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }
        function f(e) {
          this.map = {}, e instanceof f ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }
        function l(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }
        function h(e) {
          return new Promise(function (t, r) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              r(e.error);
            };
          });
        }
        function y(e) {
          var t = new FileReader(),
            r = h(t);
          return t.readAsArrayBuffer(e), r;
        }
        function d(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }
        function p() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i.arrayBuffer && i.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = d(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : i.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || s(e)) ? this._bodyArrayBuffer = d(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, i.blob && (this.blob = function () {
            var e = l(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? l(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(y);
          }), this.text = function () {
            var e,
              t,
              r,
              n = l(this);
            if (n) return n;
            if (this._bodyBlob) return e = this._bodyBlob, r = h(t = new FileReader()), t.readAsText(e), r;
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) r[n] = String.fromCharCode(t[n]);
              return r.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, i.formData && (this.formData = function () {
            return this.text().then(b);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }
        f.prototype.append = function (e, t) {
          e = u(e), t = a(t);
          var r = this.map[e];
          this.map[e] = r ? r + ", " + t : t;
        }, f.prototype.delete = function (e) {
          delete this.map[u(e)];
        }, f.prototype.get = function (e) {
          return e = u(e), this.has(e) ? this.map[e] : null;
        }, f.prototype.has = function (e) {
          return this.map.hasOwnProperty(u(e));
        }, f.prototype.set = function (e, t) {
          this.map[u(e)] = a(t);
        }, f.prototype.forEach = function (e, t) {
          for (var r in this.map) this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
        }, f.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push(r);
          }), c(e);
        }, f.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), c(e);
        }, f.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push([r, t]);
          }), c(e);
        }, i.iterable && (f.prototype[Symbol.iterator] = f.prototype.entries);
        var v = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function _(e, t) {
          if (!(this instanceof _)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          var r,
            n,
            i = (t = t || {}).body;
          if (e instanceof _) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);
          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), v.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(i), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
            var o = /([?&])_=[^&]*/;
            o.test(this.url) ? this.url = this.url.replace(o, "$1_=" + new Date().getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
          }
        }
        function b(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var r = e.split("="),
                n = r.shift().replace(/\+/g, " "),
                i = r.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(n), decodeURIComponent(i));
            }
          }), t;
        }
        function m(e, t) {
          if (!(this instanceof m)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
        }
        _.prototype.clone = function () {
          return new _(this, {
            body: this._bodyInit
          });
        }, p.call(_.prototype), p.call(m.prototype), m.prototype.clone = function () {
          return new m(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new f(this.headers),
            url: this.url
          });
        }, m.error = function () {
          var e = new m(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var g = [301, 302, 303, 307, 308];
        m.redirect = function (e, t) {
          if (-1 === g.indexOf(t)) throw new RangeError("Invalid status code");
          return new m(null, {
            status: t,
            headers: {
              location: e
            }
          });
        };
        var O = t.DOMException = n.DOMException;
        try {
          new O();
        } catch (e) {
          t.DOMException = O = function (e, t) {
            this.message = e, this.name = t;
            var r = Error(e);
            this.stack = r.stack;
          }, O.prototype = Object.create(Error.prototype), O.prototype.constructor = O;
        }
        function q(e, t) {
          return new Promise(function (o, s) {
            var u = new _(e, t);
            if (u.signal && u.signal.aborted) return s(new O("Aborted", "AbortError"));
            var c = new XMLHttpRequest();
            function l() {
              c.abort();
            }
            c.onload = function () {
              var e,
                t,
                r = {
                  status: c.status,
                  statusText: c.statusText,
                  headers: (e = c.getAllResponseHeaders() || "", t = new f(), e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function (e) {
                    return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                  }).forEach(function (e) {
                    var r = e.split(":"),
                      n = r.shift().trim();
                    if (n) {
                      var i = r.join(":").trim();
                      t.append(n, i);
                    }
                  }), t)
                };
              r.url = "responseURL" in c ? c.responseURL : r.headers.get("X-Request-URL");
              var n = "response" in c ? c.response : c.responseText;
              setTimeout(function () {
                o(new m(n, r));
              }, 0);
            }, c.onerror = function () {
              setTimeout(function () {
                s(new TypeError("Network request failed"));
              }, 0);
            }, c.ontimeout = function () {
              setTimeout(function () {
                s(new TypeError("Network request failed"));
              }, 0);
            }, c.onabort = function () {
              setTimeout(function () {
                s(new O("Aborted", "AbortError"));
              }, 0);
            }, c.open(u.method, function (e) {
              try {
                return "" === e && n.location.href ? n.location.href : e;
              } catch (t) {
                return e;
              }
            }(u.url), !0), "include" === u.credentials ? c.withCredentials = !0 : "omit" === u.credentials && (c.withCredentials = !1), "responseType" in c && (i.blob ? c.responseType = "blob" : i.arrayBuffer && u.headers.get("Content-Type") && -1 !== u.headers.get("Content-Type").indexOf("application/octet-stream") && (c.responseType = "arraybuffer")), !t || "object" !== r(t.headers) || t.headers instanceof f ? u.headers.forEach(function (e, t) {
              c.setRequestHeader(t, e);
            }) : Object.getOwnPropertyNames(t.headers).forEach(function (e) {
              c.setRequestHeader(e, a(t.headers[e]));
            }), u.signal && (u.signal.addEventListener("abort", l), c.onreadystatechange = function () {
              4 === c.readyState && u.signal.removeEventListener("abort", l);
            }), c.send(void 0 === u._bodyInit ? null : u._bodyInit);
          });
        }
        q.polyfill = !0, n.fetch || (n.fetch = q, n.Headers = f, n.Request = _, n.Response = m);
      },
      900: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n,
          i = (n = r(128)) && n.__esModule ? n : {
            default: n
          },
          o = {
            providers: function (e) {
              if (e) return i.default;
              console.error("Kindly provide valid provider.");
            },
            policies: {
              IGNORE_CACHE: -1,
              ONLY_NETWORK: 0,
              CACHE_ELSE_NETWORK: 1,
              NETWORK_ELSE_CACHE: 2,
              CACHE_THEN_NETWORK: 3
            }
          };
        t.default = o;
      },
      128: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(821)),
          i = {};
        function o(e, t) {
          !t && e && e.length && e.push("");
          var r = void 0,
            i = n.getKeys(),
            o = n.getStorage();
          if (e && e.length) {
            r = e.join(".");
            for (var s = 0, u = i.length; s < u; s++) i[s] && 0 === i[s].indexOf(r) && delete o[i[s]];
          } else for (var a = 0, c = i.length; a < c; a++) delete o[i[a]];
        }
        i.get = function (e, t) {
          try {
            t(null, n.get(e));
          } catch (e) {
            t(e);
          }
        }, i.set = function (e, t, r) {
          try {
            e && t && n.set(e, t), r();
          } catch (e) {
            r(e);
          }
        }, i.clearByContentType = function () {
          try {
            if (2 === arguments.length || 3 === arguments.length) {
              var e = Array.prototype.slice.call(arguments),
                t = e.splice(-1, 1).pop(),
                r = [];
              r.push.apply(r, e), o(r), t();
            }
          } catch (e) {
            callback(e);
          }
        }, i.clearByQuery = function (e, t) {
          try {
            for (var r = n.getKeys(), i = n.getStorage(), o = 0, s = r.length; o < s; o++) r[o] && ~r[o].indexOf(e) && delete i[r[o]];
            t();
          } catch (e) {
            t(e);
          }
        }, i.clearAll = function (e) {
          try {
            o(), e();
          } catch (t) {
            e(t);
          }
        }, t.default = i;
      },
      821: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        };
        t.get = function (e) {
          var t = o.default.getItem(e);
          try {
            t = JSON.parse(t);
          } catch (e) {
            return t;
          }
          return t || null;
        }, t.set = function (e, t) {
          try {
            "object" === (void 0 === t ? "undefined" : n(t)) ? o.default.setItem(e, JSON.stringify(t)) : o.default.setItem(e, t);
          } catch (e) {}
        }, t.getStorage = function () {
          return o.default || null;
        }, t.getKeys = function () {
          return o.default ? Object.keys(o.default) : [];
        };
        var i,
          o = (i = r(769)) && i.__esModule ? i : {
            default: i
          };
      },
      32: (e, t, r) => {
        var n = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          i = u(r(533)),
          o = u(r(900)),
          s = u(r(764));
        function u(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var a = function () {
          function e() {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), this.CachePolicy = o.default.policies, this.Region = s.default, this.Utils = r(776);
          }
          return n(e, [{
            key: "Stack",
            value: function () {
              for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
              return new (Function.prototype.bind.apply(i.default, [null].concat(t)))();
            }
          }]), e;
        }();
        e.exports = new a();
      },
      764: (e, t) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = {
          EU: "eu",
          US: "us",
          AZURE_NA: "azure-na",
          AZURE_EU: "azure-eu"
        };
      },
      777: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        };
        t.default = function (e, t) {
          var r = e.requestParams;
          return new Promise(function (i, o) {
            var s = void 0;
            return r.headers["Content-Type"] = "application/json; charset=UTF-8", r.headers["X-User-Agent"] = "contentstack-web/" + u, r.body && "object" === n(r.body) && (delete r.body._method, "object" === n(r.body.query) && 0 === Object.keys(r.body.query).length && delete r.body.query, s = function e(t, r) {
              var i = [];
              if ("object" === (void 0 === t ? "undefined" : n(t)) && void 0 !== t.length) for (var o = 0, s = t.length; o < s; o++) i.push(r + "[]=" + t[o]);else for (var u in t) {
                var a = r ? r + "[" + u + "]" : u,
                  c = t[u];
                i.push(null !== c && "object" === (void 0 === c ? "undefined" : n(c)) && "query" !== u ? e(c, a) : a + "=" + encodeURIComponent("query" !== u ? c : JSON.stringify(c)));
              }
              return i.join("&");
            }(r.body)), a(e, s, t, i, o, t.retryDelay, t.retryLimit);
          });
        };
        var i,
          o = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          s = (i = r(589)) && i.__esModule ? i : {
            default: i
          },
          u = "3.17.1";
        function a(e, t, r, n, i) {
          var u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 300,
            c = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 5,
            f = e.requestParams,
            l = f.url + "?" + t,
            h = f.headers,
            y = o.mergeDeep({
              method: "GET",
              headers: h,
              timeout: 3e4
            }, r);
          r.debug && r.logHandler("info", {
            url: l,
            option: y
          });
          var d = {
              url: l,
              option: y
            },
            p = e.plugins;
          if (p && void 0 !== p) for (var v = 0; v < p.length; v++) "function" == typeof p[v].onRequest && (d = p[v].onRequest(e, d));
          (0, s.default)(d.url, d.option).then(function (o) {
            r.debug && r.logHandler("info", o);
            var s = o.json();
            if (o.ok && 200 === o.status) s.then(function (t) {
              for (var r = 0; r < p.length && "function" == typeof p[r].onResponse; r++) t = p[r].onResponse(e, d, o, t);
              n(t);
            });else {
              var f = o.status,
                l = o.statusText;
              s.then(function (s) {
                var h = {
                  error_message: s.error_message,
                  error_code: s.error_code,
                  errors: s.errors,
                  status: f,
                  statusText: l
                };
                r.retryCondition && r.retryCondition(o) ? function (o) {
                  if (0 === c) r.debug && r.logHandler("error", o), i(o);else {
                    var s = u;
                    c -= 1;
                    var f = r.retryLimit - c;
                    r.retryDelayOptions && (r.retryDelayOptions.base ? s = r.retryDelayOptions.base * f : r.retryDelayOptions.customBackoff && (s = r.retryDelayOptions.customBackoff(f, o))), function (e) {
                      return new Promise(function (t) {
                        setTimeout(t, e);
                      });
                    }(s).then(function () {
                      return a(e, t, r, n, i, u, c);
                    }).catch(function () {
                      return a(e, t, r, n, i, u, c);
                    });
                  }
                }(h) : (r.debug && r.logHandler("error", h), i(h));
              }).catch(function () {
                r.debug && r.logHandler("error", {
                  status: f,
                  statusText: l
                }), i({
                  status: f,
                  statusText: l
                });
              });
            }
          }).catch(function (e) {
            r.debug && r.logHandler("error", e), i(e);
          });
        }
      },
      540: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = function (e, t) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return function (e, t) {
              var r = [],
                n = !0,
                i = !1,
                o = void 0;
              try {
                for (var s, u = e[Symbol.iterator](); !(n = (s = u.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0);
              } catch (e) {
                i = !0, o = e;
              } finally {
                try {
                  !n && u.return && u.return();
                } finally {
                  if (i) throw o;
                }
              }
              return r;
            }(e, t);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          },
          i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          };
        t.transform = function (e) {
          return function () {
            switch (this._query[e] = this._query[e] || {}, arguments.length) {
              case 1:
                if (Array.isArray(arguments[0]) || "string" == typeof arguments[0]) {
                  var t = this._query[e].BASE || [];
                  return t = t.concat(arguments[0]), this._query[e].BASE = t, this;
                }
                console.error("Kindly provide valid parameters");
                break;
              case 2:
                if ("string" == typeof arguments[0] && (Array.isArray(arguments[1]) || "string" == typeof arguments[1])) {
                  var r = this._query[e][arguments[0]] || [];
                  return r = r.concat(arguments[1]), this._query[e][arguments[0]] = r, this;
                }
                console.error("Kindly provide valid parameters");
                break;
              default:
                console.error("Kindly provide valid parameters");
            }
          };
        }, t._type = function (e) {
          var t = void 0 === e ? "undefined" : i(e);
          return "object" === t && Array.isArray(e) && (t = "array"), t;
        }, t.mergeDeep = function (e, t) {
          var r = this;
          return function e(t, n) {
            for (var i in n) "object" == r._type(n[i]) && r._type(t[i]) == r._type(n[i]) ? e(t[i], n[i]) : "array" == r._type(n[i]) && r._type(t[i]) == r._type(n[i]) ? t[i] = t[i].concat(n[i]) : t[i] = n[i];
          }(e, t), e;
        }, t.merge = a, t.isBrowser = function () {
          return "undefined" != typeof window && "object" === ("undefined" == typeof process ? "undefined" : i(process)) && "browser" === process.title;
        }, t.parseQueryFromParams = c, t.getHash = f, t.generateHash = l, t.resultWrapper = h, t.spreadResult = y, t.sendRequest = function (e, t) {
          var r = e.environment_uid;
          r ? e._query.environment_uid = r : (e._query || (e._query = {}), e._query.environment = e.environment);
          var n = e,
            s = void 0 !== n.queryCachePolicy ? n.queryCachePolicy : n.cachePolicy,
            u = void 0 !== n.tojson && n.tojson,
            l = !!(n.entry_uid || n.singleEntry || n.asset_uid),
            p = f(c(n, l, u));
          if (e && e.requestParams && e.requestParams.body && e.requestParams.body.query) {
            var v = JSON.parse(JSON.stringify(e.requestParams.body.query));
            "object" !== (void 0 === v ? "undefined" : i(v)) && (v = JSON.parse(v)), delete e.requestParams.body.query, e.requestParams.body = a(e.requestParams.body, v), e.live_preview && !0 === e.live_preview.enable && e.live_preview.live_preview && "init" !== e.live_preview.live_preview && (e.live_preview.content_type_uid === e.content_type_uid ? (e.requestParams.body = a(e.requestParams.body, {
              live_preview: e.live_preview.live_preview || "init"
            }), s = 2, e.requestParams.body.environment && delete e.requestParams.body.environment, e.requestParams.headers.access_token && delete e.requestParams.headers.access_token, e.requestParams.headers.authorization = e.live_preview.management_token) : e.live_preview.live_preview && (s = 1));
          }
          var _ = function () {
              return function (e, t) {
                return new Promise(function (r, n) {
                  try {
                    e && n(e), u || (t = h(t)), r(y(t));
                  } catch (e) {
                    n(e);
                  }
                });
              };
            },
            b = function (r, i, a) {
              r && (0, o.default)(e, t).then(function (t) {
                try {
                  n.entry_uid = n.asset_uid = n.tojson = n.queryCachePolicy = void 0;
                  var r = {},
                    o = {};
                  if (e.singleEntry) {
                    if (e.singleEntry = !1, t.schema && (r.schema = t.schema), t.content_type && (r.content_type = t.content_type, delete r.schema), t.entries && t.entries.length) r.entry = t.entries[0];else {
                      if (!t.assets || !t.assets.length) return 2 === s && null !== n.provider ? void n.provider.get(p, _()) : a({
                        error_code: 141,
                        error_message: "The requested entry doesn't exist."
                      });
                      r.assets = t.assets[0];
                    }
                  } else t.items ? o = {
                    items: t.items,
                    pagination_token: t.pagination_token,
                    sync_token: t.sync_token,
                    total_count: t.total_count
                  } : r = t;
                  return -1 !== s && null !== n.provider ? (n.provider.set(p, r, function (e) {
                    try {
                      return e && a(e), u || (r = h(r)), i(y(r));
                    } catch (e) {
                      return a(e);
                    }
                  }), i(y(r))) : Object.keys(o).length ? i(o) : (u || (r = h(r)), i(y(r)));
                } catch (e) {
                  return a({
                    message: e.message
                  });
                }
              }.bind(n)).catch(function (e) {
                if (2 !== s || null === n.provider) return a(e);
                n.provider.get(p, _());
              });
            };
          switch (s) {
            case 1:
              return new Promise(async function (r, i) {
                null !== n.provider ? await n.provider.get(p, async function (n, o) {
                  try {
                    if (n || !o) b(!0, r, i);else {
                      try {
                        if (e._query && Array.isArray(e._query.include) && e._query.include.length > 0) {
                          var s = (a = e._query.include, c = {}, a.forEach(function (e) {
                            !function (e) {
                              var t = (e = e.replace(/[\[]/gm, ".").replace(/[\]]/gm, "")).split("."),
                                r = t.pop();
                              t.reduce(function (e, t) {
                                return e[t] = e[t] || {};
                              }, c)[r] = {};
                            }(e);
                          }), c);
                          l ? await d(s, o.entry, e, t) : await Promise.all(o.entries.map(async function (r) {
                            await d(s, r, e, t);
                          }));
                        }
                      } catch (e) {}
                      try {
                        return u || (o = h(o)), r(y(o));
                      } catch (e) {
                        return i(e);
                      }
                    }
                  } catch (e) {
                    return i(e);
                  }
                  var a, c;
                }) : b(!0, r, i);
              });
            case 2:
            case 0:
            case void 0:
            case -1:
              return new Promise(function (e, t) {
                b(!0, e, t);
              });
          }
          if (3 === s) return new Promise(function (e, t) {
            null !== n.provider && n.provider.get(p, function (r, n) {
              try {
                r || !n ? t(r) : (u || (n = h(n)), e(y(n)));
              } catch (e) {
                t(e);
              }
            });
          }).then(function () {
            return new Promise(function (e, t) {
              b(!0, e, t);
            });
          }).catch(function (e) {
            return new Promise(function (e, t) {
              b(!0, e, t);
            });
          });
        };
        var o = u(r(777)),
          s = u(r(324));
        function u(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function a(e, t) {
          if (e && t) for (var r in t) e[r] = t[r];
          return e;
        }
        function c(e, t, r) {
          if (e && e.requestParams) {
            var n = a({}, e.requestParams.body && e.requestParams.body.query || {});
            return n.environment_uid && (delete n.environment_uid, n.environment = e.environment), n.environment = e.environment, {
              content_type_uid: e.content_type_uid,
              locale: n.locale || "en-us",
              query: n,
              entry_uid: e.entry_uid,
              asset_uid: e.asset_uid,
              single: t || "false",
              toJSON: r || "false",
              api_key: e.requestParams.headers ? e.requestParams.headers.api_key : ""
            };
          }
        }
        function f(e) {
          try {
            var t = l(JSON.stringify(e)),
              r = [];
            return r.push(e.content_type_uid), r.push(e.locale), e.entry_uid && r.push(e.entry_uid), e.asset_uid && r.push(e.asset_uid), r.push(t), r.join(".");
          } catch (e) {}
        }
        function l(e) {
          var t,
            r = 0,
            n = void 0;
          if (0 === e.length) return r;
          for (n = 0, t = e.length; n < t; n++) r = (r << 5) - r + e.charCodeAt(n), r |= 0;
          return r < -1 ? -1 * r : r;
        }
        function h(e) {
          if (e && void 0 !== e.entries) {
            if (e.entries && e.entries.length) for (var t = 0, r = e.entries.length; t < r; t++) e.entries[t] = (0, s.default)(e.entries[t]);else e.entries = [];
          } else if (e && e.assets && void 0 !== e.assets) {
            if (e.assets && e.assets.length) for (var n = 0, i = e.assets.length; n < i; n++) e.assets[n] = (0, s.default)(e.assets[n]);else e.assets = [];
          } else e && void 0 !== e.entry ? e.entry = (0, s.default)(e.entry) : e && void 0 !== e.asset ? e.asset = (0, s.default)(e.asset) : e && void 0 !== e.items && (e.items = (0, s.default)(e.items).toJSON());
          return e;
        }
        function y(e) {
          var t = [];
          return e && Object.keys(e).length && (void 0 !== e.entries && (t.push(e.entries), e.content_type && (t.schema = e.content_type)), void 0 !== e.assets && t.push(e.assets), void 0 === e.content_type && void 0 === e.schema || t.push(e.content_type || e.schema), void 0 !== e.count && t.push(e.count), void 0 !== e.entry && (t = e.entry, e.schema && (t.schema = e.schema), e.content_type && (t.content_type = e.content_type)), void 0 !== e.asset && (t = e.asset), void 0 !== e.items && t.push(e)), t;
        }
        async function d(e, t, r, i, s) {
          var u = r.live_preview,
            a = r.requestParams,
            c = u.content_type_uid,
            f = u.management_token;
          await async function e(t, s, l) {
            if (void 0 !== s) if (Array.isArray(s)) await Promise.all(s.map(function (r, n) {
              return e(t, r, function (e) {
                s[n] = e;
              });
            }));else if (s._content_type_uid === c) try {
              r.requestParams = JSON.parse(JSON.stringify(a));
              var h = function (e) {
                var t = [];
                return function e(r, i) {
                  0 === Object.keys(r).length ? t.push(i.substring(1)) : Object.entries(r).forEach(function (t) {
                    var r = n(t, 2),
                      o = r[0];
                    e(r[1], [i, o].join("."));
                  });
                }(e, ""), t.filter(function (e) {
                  return "" !== e;
                });
              }(t);
              r.requestParams.body.include = h, r.requestParams.body.live_preview = u.live_preview, r.requestParams.body.content_type_uid = c;
              var y = u.host.match(/^((http[s]?):(\/\/)?)?(.+)$/),
                d = (y[1] || "https://") + y[4],
                p = s.uid,
                v = d + "/v3/content_types/" + s._content_type_uid + "/entries/" + p;
              r.requestParams.url = v, r.requestParams.method = "GET", delete r.requestParams.headers.access_token, r.requestParams.headers.authorization = f;
              var _ = await (0, o.default)(r, i);
              _.entry._content_type_uid = c, _.entry.uid = p, l(_.entry);
            } catch (e) {
              console.log("errror", e);
            } else await Promise.all(Object.entries(t).map(async function (t) {
              var r = n(t, 2),
                i = r[0],
                o = r[1];
              await e(o, s[i], function () {});
            }));
          }(e, t, function () {});
        }
        Promise.prototype.spread || (Promise.prototype.spread = function (e, t) {
          return t = t || function (e) {}, this.then(function (t) {
            return e.apply(e, t);
          }).catch(function (e) {
            t(e);
          });
        });
      },
      173: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          i = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          o = function () {
            function e() {
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this._query = {}, this.only = i.transform("only"), this;
            }
            return n(e, [{
              key: "toJSON",
              value: function () {
                return this.tojson = !0, this;
              }
            }, {
              key: "addParam",
              value: function (e, t) {
                if (e && "string" == typeof e && t && "string" == typeof t) return this._query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide a valid parameters.");
              }
            }, {
              key: "includeFallback",
              value: function () {
                return this._query.include_fallback = !0, this;
              }
            }, {
              key: "includeMetadata",
              value: function () {
                return this._query.include_metadata = !0, this;
              }
            }, {
              key: "fetch",
              value: function (e) {
                if (this.asset_uid) {
                  this.requestParams = {
                    method: "POST",
                    headers: i.mergeDeep({}, this.headers),
                    url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.assets + this.asset_uid,
                    body: {
                      _method: "GET",
                      query: this._query
                    }
                  };
                  var t = i.mergeDeep(this.fetchOptions, e);
                  return i.sendRequest(i.mergeDeep({}, this), t);
                }
                e.debug && e.logHandler("error", "Kindly provide an asset uid. e.g. .Assets('asset_uid')");
              }
            }]), e;
          }();
        t.default = o;
      },
      304: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
          i = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          o = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          s = function () {
            function e() {
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this._query = {}, this.only = o.transform("only"), this.except = o.transform("except"), this;
            }
            return i(e, [{
              key: "setCacheProvider",
              value: function (e) {
                return e && "object" === (void 0 === e ? "undefined" : n(e)) && (this.provider = e), this;
              }
            }, {
              key: "setCachePolicy",
              value: function (e) {
                return "number" == typeof e && e >= -1 && e < 4 ? this._query ? this.queryCachePolicy = e : this.cachePolicy = e : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide the valid policy"), this;
              }
            }, {
              key: "includeReference",
              value: function () {
                for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                if (Array.isArray(t) || "string" == typeof t) {
                  if (arguments.length) for (var n = 0; n < arguments.length; n++) this._query.include = this._query.include || [], this._query.include = this._query.include.concat(arguments[n]);
                  return this;
                }
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a String or an Array.");
              }
            }, {
              key: "language",
              value: function (e) {
                if (e && "string" == typeof e) return this._query.locale = e, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a String.");
              }
            }, {
              key: "addQuery",
              value: function (e, t) {
                if (e && t && "string" == typeof e) return this._query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "First argument should be a String.");
              }
            }, {
              key: "includeEmbeddedItems",
              value: function () {
                return this._query.include_embedded_items = ["BASE"], this;
              }
            }, {
              key: "includeSchema",
              value: function () {
                return this._query.include_schema = !0, this;
              }
            }, {
              key: "includeReferenceContentTypeUID",
              value: function () {
                return this._query.include_reference_content_type_uid = !0, this;
              }
            }, {
              key: "includeFallback",
              value: function () {
                return this._query.include_fallback = !0, this;
              }
            }, {
              key: "includeBranch",
              value: function () {
                return this._query.include_branch = !0, this;
              }
            }, {
              key: "includeMetadata",
              value: function () {
                return this._query.include_metadata = !0, this;
              }
            }, {
              key: "includeContentType",
              value: function () {
                return this._query.include_content_type = !0, this;
              }
            }, {
              key: "includeOwner",
              value: function () {
                return this._query.include_owner = !0, this;
              }
            }, {
              key: "toJSON",
              value: function () {
                return this.tojson = !0, this;
              }
            }, {
              key: "addParam",
              value: function (e, t) {
                if (e && t && "string" == typeof e && "string" == typeof t) return this._query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "fetch",
              value: function (e) {
                var t = this.config.host + ":" + this.config.port;
                if (this.live_preview && !0 === this.live_preview.enable && this.live_preview.content_type_uid === this.content_type_uid && (t = this.live_preview.host), this.entry_uid) {
                  this.requestParams = {
                    method: "POST",
                    headers: o.mergeDeep({}, this.headers),
                    url: this.config.protocol + "://" + t + "/" + this.config.version + this.config.urls.content_types + this.content_type_uid + this.config.urls.entries + this.entry_uid,
                    body: {
                      _method: "GET",
                      query: this._query
                    }
                  };
                  var r = o.mergeDeep(this.fetchOptions, e);
                  return o.sendRequest(o.mergeDeep({}, this), r);
                }
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide an entry uid. e.g. .Entry('asset_uid')");
              }
            }]), e;
          }();
        t.default = s;
      },
      566: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n,
          i = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
          s = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          u = (n = r(304)) && n.__esModule ? n : {
            default: n
          },
          a = function (e) {
            return function (t, r) {
              if (t && r && "string" == typeof t && void 0 !== r) return this._query.query[t] = this._query.query.file_size || {}, this._query.query[t][e] = r, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          c = function (e) {
            var t = e ? "$in" : "$nin";
            return function (e, r) {
              if (e && r && "string" == typeof e && Array.isArray(r)) return this._query.query[e] = this._query.query[e] || {}, this._query.query[e][t] = this._query.query[e][t] || [], this._query.query[e][t] = this._query.query[e][t].concat(r), this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          f = function (e) {
            return function (t) {
              if (t && "string" == typeof t) return this._query.query[t] = this._query.query[t] || {}, this._query.query[t].$exists = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          l = function (e) {
            return function () {
              for (var t = [], r = 0, n = arguments.length; r < n; r++) arguments[r] instanceof d && arguments[r]._query.query ? t.push(arguments[r]._query.query) : "object" === o(arguments[r]) && t.push(arguments[r]);
              return this._query.query[e] ? this._query.query[e] = this._query.query[e].concat(t) : this._query.query[e] = t, this;
            };
          },
          h = function (e) {
            return function (t) {
              if (t && "string" == typeof t) return this._query[e] = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a string.");
            };
          },
          y = function (e) {
            return function (t) {
              if ("number" == typeof t) return this._query[e] = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a number.");
            };
          },
          d = function (e) {
            function t() {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, t);
              var e = function (e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
              }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
              return e._query = e._query || {}, e._query.query = e._query.query || {}, e.lessThan = a("$lt"), e.lessThanOrEqualTo = a("$lte"), e.greaterThan = a("$gt"), e.greaterThanOrEqualTo = a("$gte"), e.notEqualTo = a("$ne"), e.containedIn = c(!0), e.notContainedIn = c(!1), e.exists = f(!0), e.notExists = f(!1), e.ascending = h("asc"), e.descending = h("desc"), e.beforeUid = h("before_uid"), e.afterUid = h("after_uid"), e.skip = y("skip"), e.limit = y("limit"), e.or = l("$or"), e.and = l("$and"), e;
            }
            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, e), i(t, [{
              key: "equalTo",
              value: function (e, t) {
                if (e && "string" == typeof e) return this._query.query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "where",
              value: function (e, t) {
                if (e && "string" == typeof e) return this._query.query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "count",
              value: function () {
                var e = this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version,
                  t = this.type && "asset" === this.type ? e + this.config.urls.assets : e + this.config.urls.content_types + this.content_type_uid + this.config.urls.entries;
                return this._query.count = !0, this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: t,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                }, this;
              }
            }, {
              key: "query",
              value: function (e) {
                if ("object" === (void 0 === e ? "undefined" : o(e))) return this._query.query = s.mergeDeep(this._query.query, e), this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters");
              }
            }, {
              key: "referenceIn",
              value: function (e, r) {
                var n = {};
                return r instanceof t && r._query.query ? n.$in_query = r._query.query : "object" === (void 0 === r ? "undefined" : o(r)) && (n.$in_query = r), this._query.query[e] ? this._query.query[e] = this._query.query[e].concat(n) : this._query.query[e] = n, this;
              }
            }, {
              key: "referenceNotIn",
              value: function (e, r) {
                var n = {};
                return r instanceof t && r._query.query ? n.$nin_query = r._query.query : "object" === (void 0 === r ? "undefined" : o(r)) && (n.$nin_query = r), this._query.query[e] ? this._query.query[e] = this._query.query[e].concat(n) : this._query.query[e] = n, this;
              }
            }, {
              key: "tags",
              value: function (e) {
                if (Array.isArray(e)) return this._query.tags = e, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters");
              }
            }, {
              key: "includeReferenceContentTypeUID",
              value: function () {
                return this._query.include_reference_content_type_uid = !0, this;
              }
            }, {
              key: "includeCount",
              value: function () {
                return this._query.include_count = !0, this;
              }
            }, {
              key: "addParam",
              value: function (e, t) {
                if (e && t && "string" == typeof e && "string" == typeof t) return this._query[e] = t, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "getQuery",
              value: function () {
                return this._query.query || {};
              }
            }, {
              key: "regex",
              value: function (e, t, r) {
                if (e && t && "string" == typeof e && "string" == typeof t) return this._query.query[e] = {
                  $regex: t
                }, r && (this._query.query[e].$options = r), this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "search",
              value: function (e) {
                if (e && "string" == typeof e) return this._query.typeahead = e, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
              }
            }, {
              key: "find",
              value: function (e) {
                var t = this.config.host + ":" + this.config.port;
                this.type && "asset" !== this.type && this.live_preview && !0 === this.live_preview.enable && this.live_preview.content_type_uid === this.content_type_uid && (t = this.live_preview.host);
                var r = this.config.protocol + "://" + t + "/" + this.config.version,
                  n = this.type && "asset" === this.type ? r + this.config.urls.assets : r + this.config.urls.content_types + this.content_type_uid + this.config.urls.entries;
                this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: n,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                };
                var i = s.mergeDeep(this.fetchOptions, e);
                return s.sendRequest(s.mergeDeep({}, this), i);
              }
            }, {
              key: "findOne",
              value: function () {
                var e = this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version;
                this.type && "asset" !== this.type && this.live_preview && !0 === this.live_preview.enable && this.live_preview.content_type_uid === this.content_type_uid && (e = this.config.protocol + "://" + this.live_preview.host + "/" + this.config.version);
                var t = this.type && "asset" === this.type ? e + this.config.urls.assets : e + this.config.urls.content_types + this.content_type_uid + this.config.urls.entries;
                this.singleEntry = !0, this._query.limit = 1, this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: t,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                };
                var r = s.mergeDeep({}, this.fetchOptions);
                return s.sendRequest(s.mergeDeep({}, this), r);
              }
            }]), t;
          }(u.default);
        t.default = d;
      },
      324: (e, t, r) => {
        var n = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          i = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          o = function () {
            function e(t) {
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), t && (this.object = function () {
                return t;
              }), this;
            }
            return n(e, [{
              key: "toJSON",
              value: function () {
                return this.object() ? i.mergeDeep(JSON.parse(JSON.stringify({})), this.object()) : null;
              }
            }, {
              key: "get",
              value: function (e) {
                if (this.object() && e) return e.split(".").reduce(function (e, t) {
                  return e[t];
                }, this.object());
              }
            }, {
              key: "getDownloadUrl",
              value: function (e) {
                if (this.object()) {
                  var t = this.object().url ? this.object().url : null;
                  return t ? t + "?disposition=" + (e && "string" == typeof e ? e : "attachment") : null;
                }
              }
            }]), e;
          }();
        e.exports = function (e) {
          return new o(e);
        };
      },
      533: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
          i = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          o = h(r(971)),
          s = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(r(540)),
          u = h(r(304)),
          a = h(r(173)),
          c = h(r(566)),
          f = h(r(777)),
          l = h(r(900));
        function h(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var y = [408, 429],
          d = function () {
            function e() {
              var t = this;
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.fetchOptions = {
                retryLimit: 5,
                retryCondition: function (e) {
                  return !!y.includes(e.status);
                },
                debug: !1,
                logHandler: function (e, t) {
                  "error" === e && t ? console.error("[error] " + t) : "warning" === e && t ? console.warn("[warning] " + t) : "info" === e && t && console.info("[info] " + t);
                }
              }, this.config = s.mergeDeep({}, o.default), this.plugins = [];
              for (var r = arguments.length, i = Array(r), u = 0; u < r; u++) i[u] = arguments[u];
              switch (i[0].region && void 0 !== i[0].region && "us" !== i[0].region && (this.config.host = i[0].region + "-cdn.contentstack.com"), i[0].fetchOptions && void 0 !== i[0].fetchOptions && (this.fetchOptions = s.mergeDeep(this.fetchOptions, i[0].fetchOptions)), i[0].plugins && void 0 !== i[0].plugins && i[0].plugins.forEach(function (e) {
                t.plugins.push(e);
              }), this.cachePolicy = l.default.policies.IGNORE_CACHE, this.provider = l.default.providers("localstorage"), i.length) {
                case 1:
                  if ("object" === n(i[0]) && "string" == typeof i[0].api_key && "string" == typeof i[0].delivery_token && "string" == typeof i[0].environment) return this.headers = {
                    api_key: i[0].api_key,
                    access_token: i[0].delivery_token
                  }, "object" == n(i[0].live_preview) && (this.live_preview = s.mergeDeep(this.config.live_preview, i[0].live_preview)), "string" == typeof i[0].branch && void 0 !== i[0].branch && (this.headers.branch = i[0].branch), this.environment = i[0].environment, this;
                  this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid object parameters. The specified API Key, Delivery Token, or Environment Name is invalid.");
                case 3:
                  if (this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2]) return this.headers = {
                    api_key: i[0],
                    access_token: i[1]
                  }, this.environment = i[2], this;
                  this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters.");
                case 4:
                  return this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2] ? (this.headers = {
                    api_key: i[0],
                    access_token: i[1]
                  }, this.environment = i[2]) : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters."), i[3] && ("string" == typeof i[3] && void 0 !== i[3] && "us" !== i[3] ? this.config.host = i[3] + "-cdn.contentstack.com" : "object" === n(i[3]) && (this.fetchOptions = s.mergeDeep(this.fetchOptions, i[3]))), this;
                case 5:
                  return this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2] ? (this.headers = {
                    api_key: i[0],
                    access_token: i[1]
                  }, this.environment = i[2]) : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters."), i[3] && ("string" == typeof i[3] && void 0 !== i[3] && "us" !== i[3] ? this.config.host = i[3] + "-cdn.contentstack.com" : "object" === n(i[3]) && (this.fetchOptions = s.mergeDeep(this.fetchOptions, i[3]))), i[4] && "object" === n(i[4]) && (this.fetchOptions = s.mergeDeep(this.fetchOptions, i[4])), this;
                default:
                  this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters to initialize the Contentstack javascript-SDK Stack.");
              }
            }
            return i(e, [{
              key: "setPort",
              value: function (e) {
                return "number" == typeof e && (this.config.port = e), this;
              }
            }, {
              key: "setProtocol",
              value: function (e) {
                return "string" == typeof e && ~["https", "http"].indexOf(e) && (this.config.protocol = e), this;
              }
            }, {
              key: "setHost",
              value: function (e) {
                return "string" == typeof e && e && (this.config.host = e), this;
              }
            }, {
              key: "setCachePolicy",
              value: function (e) {
                return "number" == typeof e && e >= -1 && e < 4 ? this._query ? this.queryCachePolicy = e : this.cachePolicy = e : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide the valid policy"), this;
              }
            }, {
              key: "livePreviewQuery",
              value: function (e) {
                this.live_preview && (this.live_preview.live_preview = e.live_preview || "init", this.live_preview.content_type_uid = e.content_type_uid, this.live_preview.entry_uid = e.entry_uid);
              }
            }, {
              key: "setCacheProvider",
              value: function (e) {
                return e && "object" === (void 0 === e ? "undefined" : n(e)) && (this.provider = e), this;
              }
            }, {
              key: "clearByQuery",
              value: function () {
                if (this.provider && "function" == typeof this.provider.clearByQuery) return this.provider.clearByQuery.apply(this.provider, arguments);
              }
            }, {
              key: "clearByContentType",
              value: function () {
                if (this.provider && "function" == typeof this.provider.clearByContentType) return this.provider.clearByContentType.apply(this.provider, arguments);
              }
            }, {
              key: "clearAll",
              value: function () {
                if (this.provider && "function" == typeof this.provider.clearAll) return this.provider.clearAll.apply(this.provider, arguments);
              }
            }, {
              key: "getCacheProvider",
              value: function () {
                return this.provider;
              }
            }, {
              key: "ContentType",
              value: function (e) {
                return e && "string" == typeof e && (this.content_type_uid = e, this.type = "contentType"), this;
              }
            }, {
              key: "Entry",
              value: function (e) {
                var t = new u.default();
                return e && "string" == typeof e && (t.entry_uid = e), s.merge(t, this);
              }
            }, {
              key: "fetch",
              value: function (e) {
                this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  plugins: this.plugins,
                  url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types + this.content_type_uid,
                  body: {
                    _method: "GET",
                    environment: this.environment
                  }
                };
                var t = s.mergeDeep(this.fetchOptions, e);
                return (0, f.default)(this, t);
              }
            }, {
              key: "Assets",
              value: function (e) {
                if (this.type = "asset", e && "string" == typeof e) {
                  var t = new a.default();
                  return t.asset_uid = e, s.merge(t, this);
                }
                return this;
              }
            }, {
              key: "Query",
              value: function () {
                var e = new c.default();
                return s.merge(e, this);
              }
            }, {
              key: "getLastActivities",
              value: function () {
                return this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types,
                  body: {
                    _method: "GET",
                    only_last_activity: !0,
                    environment: this.environment
                  }
                }, (0, f.default)(this, this.fetchOptions);
              }
            }, {
              key: "getContentTypes",
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types,
                  body: {
                    _method: "GET",
                    environment: this.environment
                  }
                }, e) for (var t in e) this.requestParams.body[t] = e[t];
                return (0, f.default)(this, this.fetchOptions);
              }
            }, {
              key: "sync",
              value: function (e, t) {
                this._query = {}, this._query = s.mergeDeep(this._query, e), this.requestParams = {
                  method: "POST",
                  headers: s.mergeDeep({}, this.headers),
                  url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.sync,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                };
                var r = s.mergeDeep(this.fetchOptions, t);
                return s.sendRequest(s.mergeDeep({}, this), r);
              }
            }, {
              key: "imageTransform",
              value: function (e, t) {
                if (e && "string" == typeof e && "object" === (void 0 === t ? "undefined" : n(t)) && void 0 === t.length) {
                  var r = [];
                  for (var i in t) r.push(i + "=" + t[i]);
                  e += e.indexOf("?") <= -1 ? "?" + r.join("&") : "&" + r.join("&");
                }
                return e;
              }
            }]), e;
          }();
        t.default = d;
      },
      589: (e, t, r) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = o(r(483)),
          i = o(r(51));
        function o(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        n.default.polyfill(), t.default = i.default;
      },
      769: (e, t) => {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function () {
          try {
            return window.localStorage;
          } catch (e) {
            return null;
          }
        }();
      }
    },
    t = {};
  return function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = t[n] = {
      exports: {}
    };
    return e[n](o, o.exports, r), o.exports;
  }(32);
})());